module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/refrigerator-f906191c5f282c2cf1823c6e09d2956f.svg";